import Text from 'components/Text/Text';
import React, { useCallback } from 'react';
import Button from 'components/Button/Button';
import breadcrumbs from 'images/breadcrumbs.svg';
import { TTypeOfEditVideoModalWindow } from '../../../../../../../../editVideoState/editVideoContext';
import style from './CreateStudioBtn.module.scss';

interface ICreateStudioBtn {
	changeTypeOfModalWindow: (value: TTypeOfEditVideoModalWindow) => void;
}

const CreateStudioBtn: React.FC<ICreateStudioBtn> = ({ changeTypeOfModalWindow }) => {
	const handleCreate = useCallback(() => {
		changeTypeOfModalWindow('createStudio');
	}, [changeTypeOfModalWindow]);

	return (
		<Button
			className={style.btn}
			data-test="CreateStudioBtn"
			icon={
				<svg className={style.icon}>
					<use xlinkHref={`${breadcrumbs}#plus`} />
				</svg>
			}
			onClick={handleCreate}>
			<Text translationNameSpace="form" translationKey="createStudioButton" asFragment={true} />
		</Button>
	);
};

export default React.memo(CreateStudioBtn);
